// Toggle job search alert  ***********************
// pathname: /v1/job-search-alert/toggle/{id}
// **********************************************************
import { GenericV1ErrorsArray, useSwrMutationApi } from '@hooks/useSwrApi';

interface UseSwrToggleJobSearchAlertProps {
  locale?: Locale;
  id: number;
  channel?: number;
  successCallback?: () => void;
  errorCallback?: (errors: GenericV1ErrorsArray) => void;
}

/**
 * @description SWR mutation: Toggle job search alert by id and optional channel.
 * @param locale - string. The locale to use for the request. Default: 'ro'.
 * @param id - number. The id of the job search alert to toggle.
 * @param channel - number. The channel of notification to toggle.
 * @param successCallback - function. The callback to execute after successful toggle.
 * @param errorCallback - function. The callback to execute on error.
 */
export const useSwrToggleJobSearchAlert = (props: UseSwrToggleJobSearchAlertProps) => {
  const {
    locale,
    id,
    channel,
    successCallback,
    errorCallback,
  } = props;

  // SWR mutation
  // ********************************************
  const {
    data, error, isMutating, reset, trigger,
  } = useSwrMutationApi<ApiSchema<'JobSearchAlertData'>, never>({
    url: `/v1/job-search-alert/toggle/${id}${channel !== undefined ? `?channel=${channel}` : ''}`,
    locale,
    fetcherConfig: {
      method: 'POST',
    },
    apiOptions: {
      onSuccess: () => {
        if (successCallback) successCallback();
      },
      onError: (errors) => {
        if (errorCallback) errorCallback(errors);
      },
    },
    toastsOptions: {
      showSuccessToast: true,
      showErrorToast: true,
    },
  });

  // Return data
  // ********************************************
  return {
    data,
    error,
    isMutating,
    reset,
    trigger,
  };
};

